import React from "react";

/**
 * ChitTrack logo mark.
 *
 * Symbolism:
 * - Rounded square represents a chit "ticket" or coin
 * - Rupee (₹) stroke inside = money
 * - Small gold spark top-right = growth / saving / adding
 *
 * Use `tone="light"` when placed on a dark background to get a white mark on brand blue.
 * Use `tone="dark"` (default) for placement on light backgrounds.
 */
export function ChitLogo({ className = "h-10 w-10", tone = "dark", showSpark = true }) {
  const fill = tone === "light" ? "#FFFFFF" : "#1A3C6E";
  const stroke = tone === "light" ? "#1A3C6E" : "#FFFFFF";
  return (
    <svg
      viewBox="0 0 48 48"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ChitTrack"
    >
      {/* Rounded tile backdrop */}
      <rect x="2" y="2" width="44" height="44" rx="12" fill={fill} />
      {/* Rupee mark */}
      <path
        d="M15 14 H33 M15 20 H33 M20 14 C28 14 28 22 20 22 L15 22 L30 34"
        stroke={stroke}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Growth spark — savings accruing */}
      {showSpark && (
        <g>
          <circle cx="40" cy="10" r="5" fill="#F5D78E" stroke={fill} strokeWidth="1.5" />
          <path
            d="M40 8 L40 12 M38 10 L42 10"
            stroke={fill}
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>
      )}
    </svg>
  );
}

export default ChitLogo;
